:host {
  --padding-inline: var(--sportsline-pick-snippet-parlay-card-padding-inline, 1rem);
  --padding-block: var(--sportsline-pick-snippet-parlay-card-padding-block, 0.75rem);
  --border-radius: var(--sportsline-pick-snippet-parlay-card-border-radius, 0.5rem);
  --asset-size: 2rem;
  --label-font-size: 1.25rem; /* 20px */
  --market-font-size: 0.875rem; /* 14px */
  --metadata-font-size: 0.875rem; /* 14px */

  font-family: 'FS Industrie', FSIndustrie-Bold, industrie-standard, Helvetica, Arial, sans-serif;
  display: block;
  width: 100%;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius);
  container-type: inline-size;
  background-color: var(--Surface-Primary, #ffffff);

  &,
  & > * {
    box-sizing: border-box;
  }
}
.sportsline-pick-snippet-parlay-card.sportsline-pick-snippet-parlay-card--loading {
  min-height: 14rem;
  display: grid;
  place-items: center;
  height: 100%;
}

.sportsline-pick-snippet-parlay-card {
  display: flex;
  flex-direction: column;
  position: relative;
}

.sportsline-pick-snippet-parlay-card-label {
  display: inline-flex;
  padding: 0.375rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.5rem;
  background: var(--Utility-UI-Background-Hover, #f2f2f2);
  /* leading-trim: both;
  text-edge: cap; */
  color: var(--Brand-Primary, #004ace); /* TODO: Changing fallback from (#10d669) to CBS blue until release on 8/19 */
  /* font-family: 'FS Industrie Nw'; */
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 12px */
  letter-spacing: 0.96px;
  text-transform: uppercase;

  svg {
    width: 0.5rem;
    height: 0.5rem;
  }
  svg * {
    fill: currentColor;
  }
}

.sportsline-pick-snippet-parlay-card__header {
  display: flex;
  justify-content: space-between;
  padding-inline: var(--padding-inline);
  padding-block: var(--padding-block);
  gap: 0.5rem;
}

.sportsline-pick-snippet-parlay-card__legs {
  display: flex;
  flex-direction: column;
}

.sportsline-pick-snippet-parlay-card__legs > * {
  border-bottom: 1px solid var(--Surface-Tertiary, #f5f6f7);
}

.sportsline-pick-snippet-parlay-card__footer {
  display: flex;
  align-items: center;
  padding-inline: var(--padding-inline);
  padding-block: var(--padding-block);
}

.sportsline-pick-snippet-parlay-card__footer-content {
  display: flex;
  flex-wrap: wrap;
  gap: var(--padding-block);
}

.sportsline-pick-snippet-parlay-card__leg {
  display: flex;
  gap: 0.635rem;
  padding-block: var(--padding-block);
  --card-color: var(--sportsline-pick-snippet-parlay-card-color, #c2c2c2);
}

.sportsline-pick-snippet-parlay-card__leg-color {
  min-height: 100%;
  background-color: var(--card-color);
  border-radius: 0 var(--card-color-width) var(--card-color-width) 0;
  width: var(--card-color-width, 0.375rem);
  min-width: var(--card-color-width);
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
}

.sportsline-pick-snippet-parlay-card__leg-selection {
  display: flex;
  align-items: center;
  /* flex-direction: column; */
  gap: 1rem;
  flex: 1;
  font-size: var(--label-font-size);
  padding-right: var(--padding-inline);
}

.sportsline-pick-snippet-parlay-card__leg-selection__info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.sportsline-pick-snippet-parlay-card__action {
  margin-left: auto;
}

sportsline-player-avatar {
  --sportsline-player-avatar-size-medium: var(--asset-size);
}
sportsline-team-logo {
  --sportsline-team-logo-size-medium: var(--asset-size);
}
sportsline-over-under-image {
  --sportsline-over-under-image-size-medium: var(--asset-size);
}

.sportsline-pick-snippet-parlay-card__leg-selection__label {
  color: var(--Text-Primary, #202121);
  font-size: var(--label-font-size);
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
}

.sportsline-pick-snippet-parlay-card__leg-selection__metadata {
  color: var(--Text-Tertiary, #767676);
  font-size: var(--metadata-font-size);
  font-style: normal;
  font-weight: 500;
  line-height: 1; /* 14px */
}

.sportsline-pick-snippet-parlay-card__leg-selection__odds {
  font-size: 0.75rem; /* 12px */
  margin-left: auto;
  color: var(--Text-Tertiary, #767676);
  font-style: normal;
  font-weight: 500;
  line-height: 1;
}

.sportsline-pick-snippet-parlay-card__info {
  color: var(--Text-Tertiary, #767676);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1; /* 14.4px */
  letter-spacing: 0.96px;
  text-transform: uppercase;
  margin-left: auto;
}

.sportsline-pick-snippet-parlay-card__info strong {
  color: var(--Text-Primary, #202121);
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1; /* 16.8px */
  letter-spacing: initial;
}

.sportsline-pick-snippet-parlay-card__market {
  color: var(--Text-Primary, #202121);
  font-size: var(--market-font-size); /* 14px */
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5ch;

  > span:not(:first-child) {
    line-height: 1;
  }
}

@media (max-width: 480px), screen and (max-width: 480px) {
  :host {
    --label-font-size: 1rem;
    --market-font-size: 0.75rem;
    --metadata-font-size: 0.75rem;
    --asset-size: 2.5rem;
  }
  .sportsline-pick-snippet-parlay-card__leg-selection__info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  .sportsline-pick-snippet-parlay-card__footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem; /* 12px */
  }
  .sportsline-pick-snippet-parlay-card__footer-content {
    align-items: center;
    flex: 1;
    width: 100%;
  }
  .sportsline-pick-snippet-parlay-card__info:last-child {
    margin-left: auto;
  }
  .sportsline-pick-snippet-parlay-card__action {
    flex: 1;
    margin: initial;
    width: 100%;
  }
}

@container (max-width: 480px) {
  .sportsline-pick-snippet-parlay-card {
    --label-font-size: 1rem;
    --market-font-size: 0.75rem;
    --metadata-font-size: 0.75rem;
    --asset-size: 2.5rem;
  }
  .sportsline-pick-snippet-parlay-card__leg-selection__info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  .sportsline-pick-snippet-parlay-card__footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem; /* 12px */
  }
  .sportsline-pick-snippet-parlay-card__footer-content {
    align-items: center;
    flex: 1;
    width: 100%;
  }
  .sportsline-pick-snippet-parlay-card__info:last-child {
    margin-left: auto;
  }
  .sportsline-pick-snippet-parlay-card__action {
    flex: 1;
    margin: initial;
    width: 100%;
  }
}
